<template>
    <Dialog v-model="dialog" title="COTAS DISPONÍVEIS" show-close-button>
        <div class="position-relative">
            <chips-editaveis
                    :allowed-values="allowedCotas"
                    :value.sync="cotasEscolhidas"
                    select-quote-text="Selecione as cotas que deseja reservar:"
                    duplicate-text-template="Cota {value} já está na lista de cotas escolhidas!"
                    not-available-text-template="Cota {value} não está disponível."
                    closest-available-text-template="A cota mais próxima disponível é a {value}"
                    available-for-reserve-text-template="Cota {value} disponível para reserva!"
                    confirm-button-text-template="CONFIRMAR {value}"
                    note-text="Ao selecionar a cota já reservada você pode alterá-la*"
                    :key="chipEditavelKey"
                    @editing="handleEditingInput"
            />
        </div>
        <v-layout class="justify-space-between">
            <v-btn id="ButtonVoltar" v-if="showBackButton" class="col-5 col-md-3" color="secondary" @click="voltar()" text> Voltar </v-btn>
            <v-btn id="ButtonReservarCota" :disabled="isEditingInput" class="col-5 col-md-6 offset-md-3 " color="primary" @click="selecionarCota">
                Reservar {{ quantidadeCotas > 1 ? 'Cotas' : 'Cota' }}
            </v-btn>
        </v-layout>
    </Dialog>
</template>

<script>
  import { mapState } from 'vuex'
  import { alert, notification } from '@/plugins/helpers'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  import { AlertTypes } from '../plugins/alerts_types'
  import ChipsEditaveis from '../components/ChipsEditaveis'

  export default {
    name: 'DialogListagemCotas',
    components: { ChipsEditaveis },
    props: {
      value: { type: Boolean, default: false },
      dados: {
        type: Object
      },
      showBackButton: { type: Boolean, default: false },
      quantidadeCotas: { type: Number, required: true }
    },
    data: () => ({
      term: null,
      cotas: [],
      reserva: {},
      dialog: false,
      auto_selecionado: true,
      cotasEscolhidas: [],
      chipEditavelKey: 1,
      isEditingInput: false
    }),
    computed: {
      ...mapState([
        'id_comissionado_venda',
        'id_comissionado',
        'id_empresa',
        'jornada_venda'
      ]),
      multiplasCotas () {
        return this.quantidadeCotas > 1
      },
      allowedCotas () {
        return this.cotas.map(cota => cota.CD_Cota.toString())
      }
    },
    watch: {
      value (val) {
        this.dialog = val
        if (val) {
          this.cotasEscolhidas = []
          this.$http.get('/reservas/cotas', {
            params: {
              ID_Empresa: this.dados.ID_Empresa,
              ID_Grupo: this.dados.ID_Grupo
            }
          })
            .then(result => {
              this.cotas = result.data
              if (!this.cotas) {
                throw Error('Grupo sem cota disponível para a reserva.')
              }

              // Embaralhar cotas
              const shuffledCotas = _.shuffle(this.cotas)

              // Selecionar cotas aleatórias
              const selectedCotas = shuffledCotas
                .slice(0, this.quantidadeCotas) // Seleciona 'quantidadeCotas' cotas aleatórias
                .map(cota => cota.CD_Cota) // Extrai os CD_Cota como números

              // Ordenar as cotas selecionadas em ordem crescente
              selectedCotas.sort((a, b) => a - b)

              // Converter para string para usar no componente
              this.cotasEscolhidas = selectedCotas.map(cota => cota.toString())

              this.auto_selecionado = true
            })
            .catch(() => notification(AlertTypes.ERROR, 'Ocorreu uma falha na comunicação com o Newcon, tente novamente mais tarde! Caso persistir, por favor, entre em contato com a Administradora.'))
        } else {
          this.term = null
        }
      },
      dialog (val) {
        this.$emit('input', val)
      }
    },
    methods: {
      trazerListaCotasFormatadas () {
        if (this.cotasEscolhidas.length <= 1) return this.cotasEscolhidas.join('')
        return `${this.cotasEscolhidas.slice(0, -1).join(', ')} e ${this.cotasEscolhidas[this.cotasEscolhidas.length - 1]}`
      },
      selecionarCota () {
        if (this.multiplasCotas) {
          this.reserva = { ...this.dados, cotasEscolhidas: this.cotasEscolhidas, ...this.$session.get('filial') }
        } else {
          // eslint-disable-next-line eqeqeq
          const cota = this.cotas.find((cota) => cota.CD_Cota == this.cotasEscolhidas[0])
          this.reserva = { ...this.dados, ...cota, ...this.$session.get('filial') }
        }
        const cotasFormatadas = this.trazerListaCotasFormatadas()
        alert({
          text: `Deseja reservar ${this.cotasEscolhidas.length <= 1 ? 'a cota' : 'as cotas'} ${cotasFormatadas}?`,
          buttons: {
            'Nao': { text: 'Não' },
            'Sim': () => this.reservarCotas()
          }
        })
      },
      voltar () {
        this.allowedCotas = []
        this.cotasEscolhidas = []
        this.chipEditavelKey++
        this.isEditingInput = false
        this.$emit('voltar')
      },
      async reservarCotas () {
        this.sendAnalytics()
        this.reserva.id_comissionado = this.id_comissionado_venda
        const id_unidade_negocio = this.$session.get('id_unidade_negocio')
        this.reserva.id_unidade_negocio = id_unidade_negocio
        this.$http.post('/reservas/reservarcota', this.reserva)
          .then(result => {
            this.dialog = false
            if (result.data['Msg_Erro']) {
              notification(AlertTypes.ERROR, result.data['Msg_Erro'])
            } else {
              this.reserva = { ...this.reserva, ...result.data }
              if (!this.multiplasCotas) {
                // Exibir notificação de sucesso para reserva única
                const cotasFormatadas = this.trazerListaCotasFormatadas()
                notification(AlertTypes.SUCCESS, `Cota ${cotasFormatadas} foi reservada com sucesso.`)

                setTimeout(() => {
                  alert({
                    text: `Deseja utilizar a reserva ${this.reserva.ID_Reserva}?`,
                    buttons: {
                      'Nao': { text: 'Não', handler: () => { this.$emit('reservado', this.reserva) } },
                      'Sim': () => {
                        setTimeout(() => {
                          this.$emit('reservado', this.reserva)
                          this.$emit('utilizarReserva', { ...this.reserva })
                        }, 1000)
                      }
                    }
                  })
                }, 1000)
              } else {
                sendAnalyticsEvent(this.$gtag, 'reservar_cotas_carrinho', {
                  id_usuario: this.$session.get('id_usuario'),
                  pv: this.$session.get('id_ponto_venda'),
                  comissionado: this.$session.get('id_comissionado'),
                  hierarquia: this.$session.get('hierarquia_comercial'),
                  qtd_cotas_reservadas: result.data.qt_cotas,
                  cd_grupo: result.data.cd_grupo,
                  marca: this.$session.get('flavor'),
                  empresa: this.$session.get('id_empresa'),
                  cota_reservada: this.cotasEscolhidas.join(', ')
                })
                this.$emit('atualizarLista')
                notification(AlertTypes.SUCCESS, 'Criação de múltiplas reservas agendado com sucesso.')
              }
            }
          })
          .catch(err => {
            notification(AlertTypes.ERROR, err, 'Não foi possível reservar a cota!')
          })
      },
      sendAnalytics () {
        sendAnalyticsEvent(this.$gtag, 'reservar_cota', {
          cota_reservada: this.cotasEscolhidas.join(', '),
          source_menu: this.jornada_venda
        })
      },
      handleEditingInput (editingIndex) {
        this.isEditingInput = editingIndex
      },
      liberarSelecao () {
        this.auto_selecionado = false
        this.term = ''
        this.$nextTick(function () {
          this.$refs.field.focus()
        })
      }
    }
  }
</script>

<style scoped>
    .alterar_button {
        position: absolute;
        height: 20px;
        top: 12px;
        right: 10px;
    }
</style>
